<template>
  <div class="detailsPage">
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="form-row mb-3">
          <div class="col-4 detailTitle">狀態：</div>
          <div class="col-8 detailText">{{ detailData.rpStatusName }}</div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-row mb-3">
          <div class="col-4 detailTitle">收據號碼：</div>
          <div class="col-8 detailText">{{ detailData.rpPublicNo }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="form-row mb-3">
          <div class="col-4 detailTitle">開立日期：</div>
          <div class="col-8 detailText">
            {{ detailData.rpOpenDate | TWDateFormat('tYY/MM/DD') }}
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-row mb-3">
          <div class="col-4 detailTitle">來源：</div>
          <div class="col-8 detailText">{{ detailData.rpSourceName }}</div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <div class="form-row mb-3">
          <div class="col-4 detailTitle">收據日期：</div>
          <div class="col-8 detailText">{{ detailData.rpDate | TWDateFormat('tYY/MM/DD') }}</div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-row mb-3">
          <div class="col-4 detailTitle">繳款人：</div>
          <div class="col-8 detailText">{{ detailData.rpPayManName }}</div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <div class="form-row mb-3">
          <div class="col-4 detailTitle">繳費方式：</div>
          <div class="col-8 detailText">{{ detailData.pmName }}</div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-row mb-3">
          <div class="col-4 detailTitle">應繳金額：</div>
          <div class="col-8 detailText">NT$ {{ detailData.rpArAmt | currencyFormat }}</div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <div class="form-row mb-3">
          <div class="col-4 detailTitle">優免金額：</div>
          <div class="col-8 detailText">NT$ {{ detailData.rpDicountAmt | currencyFormat }}</div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-row mb-3">
          <div class="col-4 detailTitle">實收金額：</div>
          <div class="col-8 detailText">NT$ {{ detailData.rpRealAmt | currencyFormat }}</div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <div class="form-row mb-3">
          <div class="col-4 detailTitle">繳款項目：</div>
          <div class="col-8 detailText">{{ detailData.piName }}</div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-row mb-3"  v-if="detailData.rpStatus == 9">
            <div class="col-4 detailTitle">作廢說明：</div>
            <div class="col-8 detailText tdText">{{ detailData.rpCancelRemark }}</div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <b-form-group label="備註：" label-cols="4" label-cols-md="2" label-class="detailTitle">
          <b-textarea
            id="form-memo"
            ref="formMemo"
            :value="detailData.rpRemark"
            rows="3"
            max-rows="6"
            readonly
            class="bg-white"
          />
        </b-form-group>
      </div>
    </div>
    <!-- 自訂 -->
    <div
      class="row"
      v-for="(item, index) in detailData.custRemarkList"
      :key="index"
      :id="item.crId"
    >
      <div class="col-12 col-md-6">
        <b-form-group :label="item.crName" label-cols="4" class="detailTitle">
          <span>{{ item.rcrValue }}</span>
        </b-form-group>
      </div>
    </div>

    <div class="form-row">
      <div class="col-4 col-md-2"></div>
      <div class="col-8 col-md-10 detailText">
        <b-form-checkbox
          onclick="return false"
          :checked="detailData.rpIsStampDuty === 'Y' ? 'true' : ''"
          >印花稅總繳</b-form-checkbox
        >
        <b-form-checkbox
          onclick="return false"
          :checked="detailData.rpIsPreOpen === 'Y' ? 'true' : ''"
          >預開收據</b-form-checkbox
        >
        <b-textarea
          v-if="detailData.rpIsPreOpen === 'Y' ? true : false"
          :value="detailData.rpPreOpenRemark"
          rows="2"
          max-rows="3"
          readonly
          class="bg-white"
        />
      </div>
    </div>

    <!-- <div class="form-actions"> -->
    <div class="mt-2">
      <div class="row align-items-center mb-4 small">
        <div class="col-12 col-md mb-3 mb-md-0" >
          <!-- <b-button
            v-if="isPayerBtn"
            :variant="
              detailData.rpHmId === '' || detailData.rpHmId === null ? 'secondary' : 'primary'
            "
            :disabled="detailData.rpHmId === '' || detailData.rpHmId === null ? true : false"
            size="sm"
            class="btn-miw payBtn"
            v-b-modal.modal-payer
            >繳款人歸戶資訊</b-button
          > -->
        </div>
        <div class="col-12 col-md-auto" style="margin: auto">
          <div class="row">
            <div class="col-12 col-md-auto mb-3 mb-md-0">
              經辦人員：{{ detailData.rpOperatorName }}
            </div>
            <div class="col-12 col-md-auto mb-3 mb-md-0">
              主辦出納：{{ detailData.rpCashierName }}
            </div>
            <div class="col-12 col-md-auto">主辦會計：{{ detailData.rpAccountName }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <b-modal
      id="modal-payer"
      ref="modalPayer"
      title="繳款人歸戶資訊"
      title-class="text-primary"
      header-class="border-bottom-0"
      footer-class="justify-content-center"
      scrollable
      ok-only
      ok-title="關閉"
      ok-variant="action"
    >
      <b-form>
        <b-form-group label="身分證" label-cols="2">
          <span>{{ detailData.rpPayManId }}</span>
        </b-form-group>

        <b-form-group label="生日" label-cols="2">
          <span>{{
            detailData.rpPayManBirthday === 'Invalid date' ? null : detailData.rpPayManBirthday
          }}</span>
        </b-form-group>

        <b-form-group label="電話1" label-cols="2">
          <span>{{ detailData.rpPayManTel1 }}</span>
        </b-form-group>

        <b-form-group label="電話2" label-cols="2">
          <span>{{ detailData.rpPayManTel2 }}</span>
        </b-form-group>

        <b-form-group label="Email" label-cols="2">
          <span>{{ detailData.rpPayManEmail }}</span>
        </b-form-group>

        <b-form-group label="地址" label-cols="2">
          <span
            >{{ detailData.rpPayManAddrZip }}{{ detailData.rpPayManAddr1
            }}{{ detailData.rpPayManAddr2 }}{{ detailData.rpPayManAddr3 }}</span
          >
        </b-form-group>
      </b-form>
    </b-modal> -->
  </div>
</template>
<script>
export default {
  name: 'DetailsPage',
  props: {
    detailData: {
      type: Object,
      default() {
        return {};
      },
    },
    // 繳款人歸戶資訊 btn 開關
    isPayerBtn: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
